import React from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../../components/Modal/Modal";
import Typography from "../../../components/Typography/Typography";
import Button from "../../../components/Button/Button";
import RadioButton from "../../../components/Radio button/RadioButton";
import TextInput from "../../../components/TextInput/TextInput";
import Textarea from "../../../components/TextArea/Textarea";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import Icons from "../../../components/Icons/Icon";
import { Dropdown } from "../../../components/DropDown/DropDown";
import ToggleButton from "../../../components/ToogleButton/ToogleButton";
import TimeTypeOffAccordion from "../../../components/Accordion/TimeTypeOffAccordion";
import TimeOffSearchType from "../../../components/TimeOffSearchType/TimeOffSearchType";
import Checkbox from "../../../components/CheckBox/CheckBox";

export const EchoPulseDatePicker = styled.div`
  overflow: hidden;
  width: 100%;
  .react-datepicker__calendar-icon {
    display: none;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker-wrapper input {
    padding: 12px 16px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #232323;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z' fill='%23292D32'/%3E%3Cpath d='M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z' fill='%23292D32'/%3E%3Cpath d='M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z' fill='%23292D32'/%3E%3Cpath d='M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z' fill='%23292D32'/%3E%3Cpath d='M8.5 14.5C8.37 14.5 8.24 14.47 8.12 14.42C8 14.37 7.89001 14.3 7.79001 14.21C7.70001 14.11 7.62999 14 7.57999 13.88C7.52999 13.76 7.5 13.63 7.5 13.5C7.5 13.24 7.61001 12.98 7.79001 12.79C7.89001 12.7 8 12.63 8.12 12.58C8.3 12.5 8.50001 12.48 8.70001 12.52C8.76001 12.53 8.82 12.55 8.88 12.58C8.94 12.6 9 12.63 9.06 12.67C9.11 12.71 9.15999 12.75 9.20999 12.79C9.24999 12.84 9.29999 12.89 9.32999 12.94C9.36999 13 9.40001 13.06 9.42001 13.12C9.45001 13.18 9.47001 13.24 9.48001 13.3C9.49001 13.37 9.5 13.43 9.5 13.5C9.5 13.76 9.38999 14.02 9.20999 14.21C9.01999 14.39 8.76 14.5 8.5 14.5Z' fill='%23292D32'/%3E%3Cpath d='M12 14.5C11.74 14.5 11.48 14.39 11.29 14.21C11.25 14.16 11.21 14.11 11.17 14.06C11.13 14 11.1 13.94 11.08 13.88C11.05 13.82 11.03 13.76 11.02 13.7C11.01 13.63 11 13.57 11 13.5C11 13.37 11.03 13.24 11.08 13.12C11.13 13 11.2 12.89 11.29 12.79C11.57 12.51 12.02 12.42 12.38 12.58C12.51 12.63 12.61 12.7 12.71 12.79C12.89 12.98 13 13.24 13 13.5C13 13.57 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.82 12.92 13.88C12.9 13.94 12.87 14 12.83 14.06C12.79 14.11 12.75 14.16 12.71 14.21C12.61 14.3 12.51 14.37 12.38 14.42C12.26 14.47 12.13 14.5 12 14.5Z' fill='%23292D32'/%3E%3Cpath d='M8.5 18C8.37 18 8.24 17.97 8.12 17.92C8 17.87 7.89001 17.8 7.79001 17.71C7.70001 17.61 7.62999 17.51 7.57999 17.38C7.52999 17.26 7.5 17.13 7.5 17C7.5 16.74 7.61001 16.48 7.79001 16.29C7.89001 16.2 8 16.13 8.12 16.08C8.49 15.92 8.92999 16.01 9.20999 16.29C9.24999 16.34 9.29999 16.39 9.32999 16.44C9.36999 16.5 9.40001 16.56 9.42001 16.62C9.45001 16.68 9.47001 16.74 9.48001 16.81C9.49001 16.87 9.5 16.94 9.5 17C9.5 17.26 9.38999 17.52 9.20999 17.71C9.01999 17.89 8.76 18 8.5 18Z' fill='%23292D32'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position-x: 97%;
    background-position-y: center;
    cursor: pointer;
    width: 100%;
  }

  .react-datepicker-wrapper input:focus {
    border: 1px solid #4a154b;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.08);
    outline: 0;
  }
  .monthlyDate .react-datepicker-popper {
    width: max-content;
  }
  .monthlyDate .react-datepicker__month-text {
    padding: 0.9rem 0;
    width: 5.1rem;
    display: inline-block;
    font-size: 0.875rem;
    margin: 0.125rem;
  }
  .monthlyDate .react-datepicker__month-text--keyboard-selected {
    background-color: #f8f8f8;
    color: #000;
    font-weight: bolder;
  }
  .monthlyDate .react-datepicker__header {
    background-color: #fff;
    border: none;
    padding-top: 1.25rem;
  }
  .monthlyDate .react-datepicker__navigation {
    align-items: center;
    display: flex;
    padding: 0;
    text-align: center;
    top: 17px;
  }
  .monthlyDate .react-datepicker__navigation--previous {
    left: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation--next {
    rigth: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation-icon:before {
    border-color: #232323;
    border-width: 1.5px 1.5px 0 0;
  }
  .monthlyDate .react-datepicker__day--in-range {
    background-color: #f15845;
  }
  .monthlyDate .react-datepicker__day--keyboard-selected {
    //  color: #fff;
  }
  .monthlyDate .react-datepicker__day--today {
    font-weight: 800;
  }
  .react-datepicker__day--selected.react-datepicker__day--today {
    color: #fff;
  }
  .react-datepicker__day--in-range.react-datepicker__day--in-range {
    color: #fff;
  }
  .react-datepicker__month-text--in-range {
    background-color: #f15845;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #ffffff;
  }
  .react-datepicker__day--selected {
    background-color: #f15845;
  }
`;
export const CustomRightToolTip = styled.div`
  .tooltip {
    position: relative;
    display: inline-block;
    z-index: 9;
    cursor: default;
    width: 100%;
    height: 14px;
  }

  .tooltiptext {
    visibility: hidden;
    max-width: 18rem;
    width: max-content;
    height: auto;
    background-color: #fff;
    font-size: 0.75rem;
    font-weight: 500;
    color: #232323;
    text-align: left;
    border-radius: 0.375rem;
    padding: 0.5rem 0.5rem;
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    left: 110%;
    filter: drop-shadow(0 0.5rem 1.5rem rgba(0, 0, 0, 0.12));
  }
  .tooltiptext::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    // margin-top: -0.625rem;
    border-width: 0.625rem;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
`;
type Props = {
  onClose: () => void;
};

const CreateTimeOffTypeModal: React.FC<Props> = ({ onClose }) => {
  return (
    <Modal isOpen onClose={onClose} placement="right" size="medium">
      <ModalHeader className="bg-gray-200">
        <Typography className="font-bold text-gray-300" variant="h3">
          Create Time Off Type
        </Typography>
      </ModalHeader>
      <ModalBody className="!ps-12 !pe-10 py-10">
        <div className="grid grid-cols-2 w-full">
          <div className="w-[24.375rem]">
            <div className="text-200 text-[#979797] uppercase font-medium tracking-[0.09rem]">
              Basic Details
            </div>
            <div className="mt-9">
              <label className="text-400 font-medium text-gray-300 block mb-2">
                Select Time off Type
                <span className="text-primary-100 ps-0.5">*</span>
              </label>
              <div className="flex justify-start items-center gap-9 mt-3 [&>.inline-block>label>span]:text-gray-300 [&>.inline-block>label>span]:font-medium">
                <RadioButton
                  label="Holiday"
                  onChange={function noRefCheck() {}}
                  name={""}
                  size="md"
                />
                <RadioButton
                  label="Leave"
                  onChange={function noRefCheck() {}}
                  name={""}
                  size="md"
                />
              </div>
            </div>
            <div className="mt-8">
              <label className="text-400 font-medium text-gray-300 block mb-2">
                Title
                <span className="text-primary-100 ps-0.5">*</span>
              </label>
              <TextInput
                type="text"
                placeholder="Enter title"
                value="Diwali Leave"
                onChange={function noRefCheck() {}}
              />
            </div>
            <div className="mt-8">
              <label className="text-400 font-medium text-gray-300 block mb-2">
                Description
              </label>
              <Textarea
                onChange={function noRefCheck() {}}
                placeholder="Add a note"
                value=""
                resize
              />
            </div>
            <div className="mt-7">
              <label className="text-400 font-medium text-gray-300 block mb-2">
                Select period
                <span className="text-primary-100 ps-0.5">*</span>
              </label>
              <EchoPulseDatePicker>
                <DatePicker
                  selectsRange={true}
                  startDate={1}
                  endDate={5}
                  onChange={function noRefCheck() {}}
                  dateFormat="dd MMM"
                />
              </EchoPulseDatePicker>
            </div>
            <div className="mt-8">
              <label className="text-400 font-medium text-gray-300 block mb-2">
                Maximum leaves (in days)
              </label>
              <TextInput
                type="text"
                placeholder="Enter days"
                value="30"
                onChange={function noRefCheck() {}}
              />
            </div>
            <div className="text-200 text-[#979797] uppercase font-medium tracking-[0.09rem] mt-16">
              Entitlement
            </div>
            <div className="mt-9">
              <label className="text-400 font-medium text-gray-300 mb-2 inline-flex">
                Effective after
                <span className="text-primary-100 ms-0.5">*</span>
                <CustomRightToolTip>
                  <div className="tooltip ms-2">
                    <div className="w-full">
                      <Icons
                        name="info-circle"
                        variant="stroke"
                        size={14}
                        color="#888888"
                        className="-mb-0.5"
                      />
                    </div>
                    <span className="tooltiptext">
                      User will not be able to make edits beyond this duration
                    </span>
                  </div>
                </CustomRightToolTip>
              </label>
              <div className="flex justify-start items-center">
                <TextInput
                  type="text"
                  placeholder="Enter title"
                  value="0"
                  onChange={function noRefCheck() {}}
                  className="!w-12 !py-[9px] rounded-e-none border-e-none"
                />
                <div className="w-[8.75rem] [&_div]:rounded-s-none [&>.select__control]:!rounded-s-none">
                  <Dropdown
                    placeholder="Select"
                    onChange={function noRefCheck() {}}
                    type="mdbox"
                    options={[
                      {
                        label: "Month()s",
                        value: "1",
                      },
                      {
                        label: "Month()s",
                        value: "2",
                      },
                      {
                        label: "Month()s",
                        value: "3",
                      },
                    ]}
                  />
                </div>
                <span className="mx-2 text-400 font-medium text-gray-300">
                  from
                </span>
                <div className="w-[12rem]">
                  <Dropdown
                    placeholder="Select"
                    onChange={function noRefCheck() {}}
                    type="mdbox"
                    options={[
                      {
                        label: "Date of joining",
                        value: "1",
                      },
                      {
                        label: "Date of joining",
                        value: "2",
                      },
                      {
                        label: "Date of joining",
                        value: "3",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="mt-8">
              <label className="text-400 font-medium text-gray-300 mb-2 inline-flex">
                Leave accrual
                <span className="text-primary-100 ms-0.5">*</span>
                <CustomRightToolTip>
                  <div className="tooltip ms-2">
                    <div className="w-full">
                      <Icons
                        name="info-circle"
                        variant="stroke"
                        size={14}
                        color="#888888"
                        className="-mb-0.5"
                      />
                    </div>
                    <span className="tooltiptext">
                      User will not be able to make edits beyond this duration
                    </span>
                  </div>
                </CustomRightToolTip>
              </label>
              <div className="flex justify-start items-center">
                <div className="w-[8.75rem]">
                  <Dropdown
                    placeholder="Select"
                    onChange={function noRefCheck() {}}
                    type="mdbox"
                    options={[
                      {
                        label: "Monthly",
                        value: "1",
                      },
                      {
                        label: "Quaterly",
                        value: "2",
                      },
                      {
                        label: "Half Yearly",
                        value: "2",
                      },
                      {
                        label: "Yearly",
                        value: "3",
                      },
                    ]}
                  />
                </div>
                <span className="mx-2 text-400 text-gray-300">on</span>
                <div className="w-[8.75rem]">
                  <Dropdown
                    placeholder="Select"
                    onChange={function noRefCheck() {}}
                    type="mdbox"
                    options={[
                      {
                        label: "Monthly",
                        value: "1",
                      },
                      {
                        label: "Quaterly",
                        value: "2",
                      },
                      {
                        label: "Half Yearly",
                        value: "2",
                      },
                      {
                        label: "Yearly",
                        value: "3",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="mt-8">
              <div className="flex justify-start items-center mb-3">
                <ToggleButton label="" onChange={function noRefCheck() {}} />
                <label className="text-gray-300 text-400 font-medium ms-1">
                  Carry Forward
                </label>
                <CustomRightToolTip>
                  <div className="tooltip ms-2">
                    <div className="w-full">
                      <Icons
                        name="info-circle"
                        variant="stroke"
                        size={14}
                        color="#888888"
                        className="-mb-0.5"
                      />
                    </div>
                    <span className="tooltiptext">
                      User will not be able to make edits beyond this duration
                    </span>
                  </div>
                </CustomRightToolTip>
              </div>
              <TextInput
                type="text"
                placeholder="Enter max limit"
                value=""
                onChange={function noRefCheck() {}}
                className="!w-36 !py-[9px]"
              />
            </div>
            <div className="mt-8">
              <label className="text-400 font-medium text-gray-300 inline-flex">
                Maximum balance (Including accrual)
                <span className="text-primary-100 ms-0.5">*</span>
                <CustomRightToolTip>
                  <div className="tooltip ms-2">
                    <div className="w-full">
                      <Icons
                        name="info-circle"
                        variant="stroke"
                        size={14}
                        color="#888888"
                        className="-mb-0.5"
                      />
                    </div>
                    <span className="tooltiptext">
                      User will not be able to make edits beyond this duration
                    </span>
                  </div>
                </CustomRightToolTip>
              </label>
              <div className="flex justify-between items-center mt-4">
                <div className="flex justify-start items-center">
                  <label className="text-400 font-medium text-gray-300 block me-2">
                    Max balance
                  </label>
                  <TextInput
                    type="text"
                    placeholder=""
                    value="0"
                    onChange={function noRefCheck() {}}
                    className="!w-11 !py-[9px]"
                  />
                </div>
                <div className="flex justify-end items-center">
                  <label className="text-400 font-medium text-gray-300 block me-2">
                    Adjusted
                  </label>
                  <div className="w-[8.75rem]">
                    <Dropdown
                      placeholder="Select"
                      onChange={function noRefCheck() {}}
                      type="mdbox"
                      options={[
                        {
                          label: "Monthly",
                          value: "1",
                        },
                        {
                          label: "Quaterly",
                          value: "2",
                        },
                        {
                          label: "Half Yearly",
                          value: "2",
                        },
                        {
                          label: "Yearly",
                          value: "3",
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[27.5rem]">
            <div className="text-200 text-[#979797] uppercase font-medium tracking-[0.09rem]">
              Applicability
            </div>
            <div className="mt-8">
              <TimeTypeOffAccordion
                items={[
                  {
                    title: (
                      <>
                        Applicable to <span>(Optional)</span>
                      </>
                    ),
                    content: (
                      <div className="w-full mt-10 border-b border-[#E8E8E8] pb-10">
                        <div className="flex justify-start items-start gap-4">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Gender",
                                value: 1,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Designations",
                                value: 2,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Locations",
                                value: 3,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Roles",
                                value: 4,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10em]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Employment Type",
                                value: 5,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="mt-6">
                          <button className="text-blue-100 text-500 font-medium">
                            <Icons
                              name="plus"
                              variant="stroke"
                              size={16}
                              className="-mb-0.5 [&>svg>path]:stroke-blue-100 [&>svg>path]:stroke-2 me-1"
                            />
                            Add Criteria
                          </button>
                        </div>
                        <div className="mt-6 text-400 font-medium text-[#8D8D8D] text-center">
                          OR
                        </div>
                        <div className="mt-2">
                          <label className="text-400 font-medium text-gray-300 block mb-2">
                            Find employee
                            <span className="text-primary-100 ps-0.5">*</span>
                          </label>
                          {/* <TimeOffSearchType /> */}
                        </div>
                      </div>
                    ),
                  },
                  {
                    title: (
                      <>
                        Not Applicable to <span>(Optional)</span>
                      </>
                    ),
                    content: (
                      <div className="w-full mt-10 border-b border-[#E8E8E8] pb-10">
                        <div className="flex justify-start items-start gap-4">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Gender",
                                value: 1,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Designations",
                                value: 2,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Locations",
                                value: 3,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10rem]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Roles",
                                value: 4,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex justify-start items-start gap-4 mt-8">
                          <div className="w-[10em]">
                            <Dropdown
                              placeholder="Select"
                              onChange={function noRefCheck() {}}
                              value={{
                                label: "Employment Type",
                                value: 5,
                              }}
                              type="box"
                              options={[
                                {
                                  label: "Gender",
                                  value: "1",
                                },
                                {
                                  label: "Designations",
                                  value: "2",
                                },
                                {
                                  label: "Locations",
                                  value: "3",
                                },
                                {
                                  label: "Roles",
                                  value: "4",
                                },
                                {
                                  label: "Employment Type",
                                  value: "5",
                                },
                              ]}
                            />
                          </div>
                          <div className="flex justify-start items-start gap-5 flex-1">
                            <div className="flex-1">
                              {/* <TimeOffSearchType /> */}
                            </div>
                            <button className="mt-4">
                              <Icons
                                name="delete"
                                variant="stroke"
                                size={18}
                                className="[&>svg>path]:stroke-primary-100"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="mt-6">
                          <button className="text-blue-100 text-500 font-medium">
                            <Icons
                              name="plus"
                              variant="stroke"
                              size={16}
                              className="-mb-0.5 [&>svg>path]:stroke-blue-100 [&>svg>path]:stroke-2 me-1"
                            />
                            Add Criteria
                          </button>
                        </div>
                        <div className="mt-6 text-400 font-medium text-[#8D8D8D] text-center">
                          OR
                        </div>
                        <div className="mt-2">
                          <label className="text-400 font-medium text-gray-300 block mb-2">
                            Find employee
                            <span className="text-primary-100 ps-0.5">*</span>
                          </label>
                          {/* <TimeOffSearchType /> */}
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
            </div>
            <div className="mt-16">
              <div className="text-200 text-[#979797] uppercase font-medium tracking-[0.09rem]">
                RESTRICTIONS
              </div>
              <div className="flex justify-start items-center mt-8">
                <ToggleButton label="" onChange={function noRefCheck() {}} />
                <label className="text-gray-300 text-400 font-medium me-1.5 ms-1">
                  Leave Sandwich Policy
                </label>
              </div>
              <div className="mt-8">
                <label className="text-400 font-medium text-gray-300 block mb-3">
                  Weekend between leave period
                  <span className="text-primary-100 ps-0.5">*</span>
                </label>
                <div>
                  <RadioButton
                    label="Count as leave"
                    onChange={function noRefCheck() {}}
                    name={""}
                    size="md"
                  />
                </div>
                <div className="mt-2">
                  <RadioButton
                    label="Don’t count as leave"
                    onChange={function noRefCheck() {}}
                    name={""}
                    size="md"
                  />
                </div>
              </div>
              <div className="mt-8">
                <label className="text-400 font-medium text-gray-300 block mb-3">
                  Holidays between leave period
                  <span className="text-primary-100 ps-0.5">*</span>
                </label>
                <div>
                  <RadioButton
                    label="Count as leave"
                    onChange={function noRefCheck() {}}
                    name={""}
                    size="md"
                  />
                </div>
                <div className="mt-2">
                  <RadioButton
                    label="Don’t count as leave"
                    onChange={function noRefCheck() {}}
                    name={""}
                    size="md"
                  />
                </div>
              </div>
              <div className="mt-8">
                <label className="text-400 font-medium text-gray-300 block mb-3">
                  Allow requests for
                  <span className="text-primary-100 ps-0.5">*</span>
                </label>
                <div className="flex justify-start items-center gap-3">
                  <Checkbox
                    onChange={function noRefCheck() {}}
                    size="md"
                    checked={true}
                  />
                  <label className="text-400 text-gray-300 font-medium -mt-1.5">
                    Past dates
                  </label>
                </div>
                <div className="flex justify-start items-center ps-4 mt-2 gap-2">
                  <div className="flex justify-start items-center gap-2">
                    <Checkbox
                      onChange={function noRefCheck() {}}
                      size="md"
                      checked={true}
                    />
                    <label className="text-400 text-gray-300 font-medium -mt-1.5">
                      Past
                    </label>
                  </div>
                  <TextInput
                    type="text"
                    placeholder="Enter title"
                    value="0"
                    onChange={function noRefCheck() {}}
                    className="!w-12 !py-[9px]"
                  />
                  <label className="text-400 text-gray-300 font-medium">
                    day(s)
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-gray-200 px-12">
        <div className="w-full flex justify-start gap-3">
          <Button
            label="Create Time off"
            onClick={() => null}
            variant="primary"
            size="large"
          />
          <Button
            label="Cancel"
            onClick={onClose}
            variant="outline"
            size="large"
          />
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default CreateTimeOffTypeModal;
